import { AppDispatch, store } from 'store/store';
import { showNotifier } from 'containers/app/appSlice';
import { NotifierTypes } from 'constants/notifierConstants';

/**
 * Common utility function to show notifications
 */
export const showNotification = (
  dispatch: AppDispatch,
  type: NotifierTypes,
  msg: string,
  duration = 4000,
  id = 'notification-id'
): void => {
  const notifications = store.getState().rootReducer.app.toastNotifications || [];
  const existingNotification = notifications?.find(notification => notification.id === id);
  if (existingNotification) return;
  dispatch(
    showNotifier({
      message: {
        primaryMessage: msg
      },
      type,
      showClose: true,
      duration,
      id: id || 'notification-id'
    })
  );
};
